<!--
 * @Author: cmchiu
 * @Date: 2023-04-06 16:44:12
 * @LastEditTime: 2023-05-17 17:28:16
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\layout\AppHeader\components\Navbar\submenu.vue
 * 
-->
<template>
    <li
        v-if="item.Visible && !item.children"
        :class="
            !item.UpperMenuID
                ? 'navbar__item d-flex align-items-center justify-content-center flex-wrap'
                : 'sub-menu__item'
        "
        @click="clickMenuItem"
    >
        <router-link
            :to="{
                path: `/${item.MenuPath}${
                    ['page', 'files', 'posts'].includes(item.ItemType) ? '?id=' + item.MenuID : ''
                }`,
            }"
            v-text="item.MenuTitle"
        ></router-link>
    </li>
    <li v-else-if="item.Visible" class="navbar__item d-flex align-items-center justify-content-center flex-wrap">
        <a href="" v-text="item.MenuTitle"></a>
        <input type="radio" name="collapse" class="sub-menu__collapse" />
        <!-- 子選單 -->
        <ul class="sub-menu__list">
            <!-- <li class="sub-menu__item" v-for="child in item.children" :key="child.MenuID">
                <router-link :to="{ path: `/${child.MenuPath}` }" v-text="child.MenuTitle"></router-link>
            </li> -->
            <submenu v-for="child in item.children" :key="child.MenuID" :item="child" />
        </ul>
    </li>
</template>

<script>
export default {
    name: 'submenu',

    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {}
    },

    methods: {
        clickMenuItem() {
            document.querySelector('#menu').checked = false
        },
    },
}
</script>
